<template>
  <div>
    <a-modal title="关联产研需求" :visible="visible" :confirm-loading="loading" @cancel="onClose" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item ref="requirementId" label="产研需求" prop="requirementId">
          <requirement-select v-model="form.requirementId" :project-id.sync="form.projectId" :only-parant="true" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { storyUpdateItem } from '@/api/project/story';
import RequirementSelect from '@/pages/project/story/components/RequirementSelect';

export default {
  components: { RequirementSelect },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        businessRequirementId: null,
        requirementId: null
      },
      rules: {
        requirementId: [{ required: true, message: '关联产研需求不能为空', trigger: 'change' }]
      }
    };
  },
  methods: {
    onClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.form.resetFields();
    },

    onOpen(businessRequirementId) {
      this.visible = true;
      this.form = { requirementId: null, businessRequirementId: businessRequirementId };
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          storyUpdateItem({ project_id: this.form.projectId, requirement_id: this.form.requirementId, key: 'business_requirements', value: [this.form.businessRequirementId] })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$message.success('关联成功');
              this.$emit('ok');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
